declare global {
	interface Window {
		_rutarget?: any;
	}
};

// Инициализация РуТаргета на ссылках

/**
 * Инициализация РуТаргета
 */
function main(): void
{
	const _rutarget = window._rutarget || [];
	
	if ( location.pathname !== '/choose/apartment/' && location.pathname !== '/progress/' )
	{
		_rutarget.push( {
			event: 'otherPage'
		} );
	}

	const links : Array<Element> = Array.from( document.querySelectorAll( 'a[href="/choose/apartment/"], a[href*="/choose/apartment/?"], a[href="/progress/"]' ) );

	links.forEach( ( it : HTMLLinkElement ) => {
		it.addEventListener( 'click', () => {
			_rutarget.push( {
				event: 'thankYou',
				conv_id: /apartment/.test( it.href ) ? 'choice_of_apartment' : 'construction_progress'
			} );
		} );
	} );
}

/**
 * Module
 */
export {
	main as default,
};


// WEBPACK FOOTER //
// ./app/Common/RuTarget/index.ts